import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"
const slugify = require('slugify');

const ImageList = ({
  key,
  heading=null,
  content=null,
  mediaPosition="left",
  imageList=null,
  buttons=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <>
      <div className="container">
        <div className="d-flex row jcc">
          <div className="col-12 col-lg-10">
            {heading &&
              <h2 className={ `content-title center ${content ? "orange-dash mb0" : ""} image-list` }>{ htmlDecode(heading) }</h2>
            }
            {content &&
              <div className="section-content center mb6" dangerouslySetInnerHTML={{ __html: content }} />
            }
          </div>
        </div>
      </div>
      <div className={ `d-flex d-md-none col-md-6 img-col mt1 media-${mediaPosition} image-list` }>
        <div className="row aife">
          {imageList && imageList.map((imageItem, index) => (
            <div className="col-6 list-img" data-target={ `li-${slugify(imageItem.title, {lower:true,remove:/[*+~.()'"!:@]/g})}` }>
              <div className={ `list-img-inner bs1 bgw ${!index ? "first" : ""}` } data-target={ `li-${slugify(imageItem.title, {lower:true,remove:/[*+~.()'"!:@]/g})}` }>
                {imageItem.image.formats.small &&
                  <img src={imageItem.image.formats.small.url.includes(cdnUrl) ? imageItem.image.formats.small.url : cdnUrl + imageItem.image.formats.small.url} alt={ imageItem.image?.alternativeText } />
                }
                {!imageItem.image.formats.small &&
                  <img src={imageItem.image.url.includes(cdnUrl) ? imageItem.image.url : cdnUrl + imageItem.image.url} alt={ imageItem.image?.alternativeText } />
                }
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={ `content-mobile col-12 col-md-8 d-flex d-md-none adv-mwc content-col image-list media-${mediaPosition} offset-md-4` }>
        <div className={`content-inner col-12 col-md-10 col-xl-7 offset-md-2 offset-lg-3`}>
          {imageList && imageList.map((imageItem, index) => (
            <div className={ `list-item-inner li-${slugify(imageItem.title, {lower:true,remove:/[*+~.()'"!:@]/g})} ${!index ? "first" : ""}` } style={{ display: index ? "none" : "" }}>
              {imageItem.title &&
                <h2 className={ `content-title ${imageItem.content ? "orange-dash" : ""} white` }>{ htmlDecode(imageItem.title) }</h2>
              }
              {imageItem.content &&
                <div className="section-content white" dangerouslySetInnerHTML={{ __html: imageItem.content }} />
              }
              {imageItem.button &&
                <Link href={ imageItem.button.link } className="button inverse mr2">{ imageItem.button.text }</Link>
              }
            </div>
          ))}
        </div>
      </div>
      <div className="adv-mwc-flex-wrapper row w-100">
        <div className={ `img-col col-md-6 media-${mediaPosition} image-list d-none d-md-flex` }>
          <div className="row aife">
            {imageList && imageList.map((imageItem, index) => (
            <div className="col-6 list-img" data-target={ `li-${slugify(imageItem.title, {lower:true,remove:/[*+~.()'"!:@]/g})}` }>
                <div className={ `list-img-inner bs1 bgw ${!index ? "first" : ""}` } data-target={ `li-${slugify(imageItem.title, {lower:true,remove:/[*+~.()'"!:@]/g})}` }>
                  {imageItem.image.formats?.small &&
                    <img src={imageItem.image.formats.small.url.includes(cdnUrl) ? imageItem.image.formats.small.url : cdnUrl + imageItem.image.formats.small.url} alt={ imageItem.image?.alternativeText } />
                  }
                  {!imageItem.image.formats?.small &&
                    <img src={imageItem.image.url.includes(cdnUrl) ? imageItem.image.url : cdnUrl + imageItem.image.url} alt={ imageItem.image?.alternativeText } />
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={ `content-desktop col-md-10 mt3 d-none d-md-flex content-col image-list media-${mediaPosition} offset-md-4 adv-mwc` }>
          <div className={`content-inner col-xs-12 col-md-6 col-xl-4 offset-md-2 offset-xl-3`}>
            {imageList && imageList.map((imageItem, index) => (
              <div className={ `list-item-inner li-${slugify(imageItem.title, {lower:true,remove:/[*+~.()'"!:@]/g})} ${!index ? "first" : ""}` } style={{ display: index ? "none" : "" }}>
                {imageItem.title &&
                  <h2 className={ `content-title ${imageItem.content ? "orange-dash" : ""} white` }>{ htmlDecode(imageItem.title) }</h2>
                }
                {imageItem.content &&
                  <div className="section-content white" dangerouslySetInnerHTML={{ __html: imageItem.content }} />
                }
                {imageItem.button &&
                  <Link href={ imageItem.button.link } className="button inverse mr2">{ imageItem.button.text }</Link>
                }
              </div>
            ))}
          </div>
        </div>
      </div>
      {buttons &&
        <div className="buttons col-12 tac mt3" style={{zIndex: 10, position: 'relative'}}>
          {buttons.map((button, index) => (
            <Link href={ button.link } className="button mr2">{ button.text }</Link>
          ))}
        </div>
      }
    </>
  )
}

export default ImageList
